import { useEffect, useState } from "react";
import { LEAD_REJECTION_REASONS } from "@/lib/meta";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export default function RejectLeadDialog({ open, onOpenChange, count = 1, onConfirm }) {
  const [code, setCode] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setCode(""); setNote(""); } }, [open]);
  const valid = code && (code !== "other" || note.trim());

  const submit = async () => { setBusy(true); try { await onConfirm(code, note); } finally { setBusy(false); } };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-md" data-testid="reject-lead-dialog">
        <DialogHeader>
          <DialogTitle>Reject {count > 1 ? `${count} leads` : "lead"}</DialogTitle>
          <DialogDescription>Pick a reason. It's logged on the lead's history and the lead can be restored later.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {LEAD_REJECTION_REASONS.map((r) => (
            <button key={r.key} onClick={() => setCode(r.key)} data-testid={`reject-reason-${r.key}`}
              className={`text-sm px-3 py-2 rounded border text-left transition-colors ${code === r.key ? "border-rose-500 bg-rose-50 text-rose-700" : "border-gray-200 text-gray-700 hover:border-gray-300"}`}>{r.label}</button>
          ))}
        </div>
        <div>
          <Label>Note {code === "other" ? "(required)" : "(optional)"}</Label>
          <Textarea value={note} onChange={(e) => setNote(e.target.value)} className="mt-1" rows={3} data-testid="reject-note" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button variant="destructive" onClick={submit} disabled={!valid || busy} data-testid="reject-confirm-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Reject</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
